<template>
  <v-dialog v-model="dialog" width="550" scrollable>
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        depressed
        class="primary"
        tile
        :disabled="disabled"
        :icon="is_mobile"
        :dark="!disabled"
        :width="is_mobile ? '' : '103px'"
        color="white"
        :height="$root.dense ? '40px' : '56px'"
      >
        <span v-if="!is_mobile">
          Search
        </span>
        <v-icon v-else>
          mdi-magnify
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text class="pb-0">
        <div
          class="d-flex align-center justify-center"
          color="primary"
          v-if="isLoading"
          style="height:200px"
        >
          <v-progress-circular indeterminate> </v-progress-circular>
        </div>
        <template v-else>
          <div
            class="d-flex align-center justify-center"
            color="primary"
            v-if="list.length == 0"
            style="height:200px"
          >
            Customer not found
          </div>
          <div v-else>
            <div v-for="(item, i) in list" :key="i">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.template_name }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    class="primary"
                    tile
                    depressed
                    @click="
                      $emit('onCustomerSelect', item);
                      dialog = false;
                    "
                  >
                    Select
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="'divider-' + i"></v-divider>
            </div>
          </div>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { customers } from "../../../assets/js/firebase";
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    phone: {
      default: ""
    }
  },
  data() {
    return {
      dialog: false,
      isLoading: true,
      list: []
    };
  },
  computed: {
    title() {
      return "Search Customer";
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.init();
      }
    }
  },
  methods: {
    async init() {
      const vm = this;
      vm.isLoading = true;
      vm.list = [];
      try {
        let snap = await customers.where("fields.Phone", "==", vm.phone).get();
        snap.forEach(item => {
          let doc = item.data();
          doc.id = item.id;
          vm.list.push(doc);
        });
        vm.isLoading = false;
      } catch (error) {
        vm.isLoading = false;
        vm.$alert.show(error.message);
      }
    }
  }
};
</script>

<style></style>
